<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZzGfII/images/cover.jpeg?1712294946814" alt="This image is the cover for the book Something Epic Vol. 1, Something Epic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Something Epic Vol. 1, Something Epic
      </h1>
      <p class="bookDescription body article font2">
        <p>IMAGINATION IS REAL. Outside our perception, creative thought takes physical form, with only a handful of individuals known as Epics able to interact with this wondrous hidden world. But for fourteen-year-old Danny Dillon, accepting these responsibilities himself won’t be easy-or safe. Lose yourself in a world of endless fantasy and creativity, where superheroes, monsters, magical creatures, and cartoon characters live and breathe alongside us. Fan-favorite Spawn and Punisher artist SZYMON KUDRANSKI introduces a world where the only limitation is your imagination. Collects groundbreaking hit series SOMETHING EPIC #1-7 “Szymon Kudranski’s Something Epic is a breath-taking book that holds one of the most powerful messages for humanity.“ - CBR.COM “If you are a fan of strange stories and emotionally laced adventures, this is a comic you are not going to want to miss.“ - Comicon.com 10/10 “Something Epic is an experience that truly lives up to it’s name.“ - thegww.com 9.5/10 “Something Epic is a comic written for all those who have looked to their imagination to escape the world around them.“ aiptcomics.com 9/10</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Szymon Kudrański, Szymon Kudrański
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73b141d2